export default function TabNavigation({
  tabs,
  activeTabId,
  onSwitch,
  onDelete,
  onAdd,
}) {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {tabs.map((tab) =>
        tabs.length > 1 ? (
          <div
            key={tab.id}
            className="flex items-center pr-4 gap-3 rounded-full border border-gray-200 bg-white"
          >
            <button
              onClick={() => onSwitch(tab.id)}
              className={`px-8 py-2 rounded-full text-sm font-medium transition-colors ${
                tab.id === activeTabId
                  ? "bg-gray-900 text-white"
                  : "bg-gray-100 text-gray-800"
              }`}
            >
              {tab.label}
            </button>

            <button
              onClick={() => onDelete(tab)}
              className="text-sm text-gray-500 hover:text-red-600"
            >
              <svg
                className="w-4 h-4 text-gray-900 dark:text-white"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18 17.94 6M18 18 6.06 6"
                />
              </svg>
            </button>
          </div>
        ) : (
          <button
            key={tab.id}
            onClick={() => onSwitch(tab.id)}
            className={`px-8 py-2 rounded-full text-sm font-medium transition-colors ${
              tab.id === activeTabId
                ? "bg-gray-900 text-white"
                : "bg-gray-100 text-gray-800"
            }`}
          >
            {tab.label}
          </button>
        )
      )}

      <button
        onClick={onAdd}
        className="w-12 h-9 rounded-full border border-blue-500 text-blue-500 flex items-center justify-center hover:bg-blue-50"
      >
        <svg
          className="w-6 h-6 text-blue-600 dark:text-white"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 7.757v8.486M7.757 12h8.486M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
          />
        </svg>
      </button>
    </div>
  );
}
